<script>
import Content from './Content.vue'
import Footer from './Footer.vue'
import Header from './Header.vue'
import axios from 'axios'
import filterTypes from './enums/filterTypes'

export default {
  props: {
    fetchParams: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    tableHeaders: {
      type: Array,
    },
    fetchConfig: {
      type: Object,
      required: true,
    },
    csvAction: {
      type: Object,
      required: false,
    },
    defaultOrderFilter: {
      type: Object,
      required: false,
    },
    disableSearch: {
      type: Boolean,
      default: false,
    },
    disableOrderByColumn: {
      type: Boolean,
      default: false,
    },
    disableSelection: {
      type: Boolean,
      default: false,
    },
    disableRequestOnMounted: {
      type: Boolean,
      default: false,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: String,
      default: 'id',
    },
  },
  components: {
    Header,
    Content,
    Footer
  },
  data() {
    return {
      selectedRows: [],
      isLoadingData: false,
      data: [],
      searchQuery: '',
      orderFilter: {
        key: null,
        type: null,
      },
      pagination: {
        currentPage: 1,
        perPage: 10,
        lastPage: 1,
        total: 0,
        from: 1,
        to: 1,
      }
    }
  },
  computed: {
    contentSlots() {
      return this.$props.tableHeaders.map(tableHeader => ({
          key: tableHeader.key,
          name: 'column-' + tableHeader.key 
      }))
    },
    filtrosParaPDFQueryString() {
      let filtros = new URLSearchParams({
        search_query: this.searchQuery ?? '',
        order_filter_key: this.orderFilter.key ?? '',
        order_filter_type: this.orderFilter.type ?? '',
      })

      return filtros.toString();
    },
    exportarCsvURL() {
      let url = new URL(this.csvAction.baseURL);
      url.search = this.filtrosParaPDFQueryString;
      return url.toString();
    },
    
  },
  methods: {
    getDatatableParams(options) {
      const currentPage = options?.currentPage ?? 1
      const orderFilterDefaultKey = this.orderFilter.key
      const orderFilterKey = orderFilterDefaultKey && (this.tableHeaders.find(tableHeader => tableHeader.key === orderFilterDefaultKey)?.sort_key ?? orderFilterDefaultKey)

      const params = {
        page: currentPage,
        per_page: this.pagination.perPage == 'Todos' ? BigInt('999999999999999999999999999999999') : this.pagination.perPage,
        search_query: this.searchQuery === '' ? null : this.searchQuery,
        order_filter_key: orderFilterKey ?? null,
        order_filter_type: this.orderFilter.type ?? null,
      }
      return params
    },
    getParams(options) {
      return {
        ...this.getDatatableParams(options),
        ...this.fetchParams,
      }
    },
    getDownloadParams(options) {
      return {
        ...this.getDatatableParams(options),
        ...this.csvAction?.params ?? {},
      }
    },
    startGetData(options) {
      if(this.isLoadingData) return
      this.$refs.contentRef.setSelectedRows([])
      const params = this.getParams(options)

      if(this.fetchConfig?.params) {
        Object.assign(params, this.fetchConfig.params)
      }      

      this.isLoadingData = true
      return axios.get(this.fetchConfig.url, { params })
        .then((response) => {
          const { data } = response
          const pagination = {
              currentPage: Number(data.current_page),
              perPage: Number(data.per_page),
              lastPage: Number(data.last_page),
              total: Number(data.total),
              from: Number(data.from),
              to: Number(data.to),
          }

          if (isNaN(pagination.currentPage) || isNaN(pagination.perPage)) {
            // Handle invalid pagination values
            this.data = [];
            this.pagination = { currentPage: 1, perPage: 10, lastPage: 1, total: 0, from: 0, to: 0 };
          } else {
            this.data = data?.data ?? [];
            this.pagination = pagination;
          }

          this.isLoadingData = false

          if(this.fetchConfig.afterRequest) this.fetchConfig.afterRequest({data: response.data })
      }).catch((error) => {
          this.isLoadingData = false
          console.error(error)
        })
    },
    handleChangePage(page) {
      this.pagination.currentPage = Number(page)
    },
    handleChangePerPage(perPage) {
      this.pagination.perPage = Number(perPage)
    },
    handleChangeSearchQuery(searchQuery) {
      this.searchQuery = searchQuery
    },
    handleChangeOrderFilter(orderFilter) {
      this.orderFilter = orderFilter
    },
    startDownloadCsv() {
      const params = this.getDownloadParams({ currentPage: this.pagination.page })
      console.log('startDownloadCsv', {params});
      axios({
        url: this.exportarCsvURL, // Replace with the appropriate Laravel route or endpoint
        method: 'GET',
        responseType: 'blob', // Important: Set the response type to 'blob'
        params: {
          descargar: true,
          ...params,
        },
      })
        .then((response) => {
          let filename = response.headers.filename ?? 'data.csv'
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch((error) => {
          console.error('Failed to download CSV:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error al descargar el archivo',
          })
        }).finally(() => {
          this.isLoadingDescargarData = false
        })
    }
  },
  mounted() {
    if(!this.disableRequestOnMounted) {
      this.startGetData()
    }
  },
  watch: {
    'pagination.currentPage': function (newPage, oldPage) {
      this.startGetData({ currentPage: newPage })
    },
    'pagination.perPage': function (newPerPage, oldPerPage) {
      this.startGetData()
    },
    'searchQuery': function (newSearchQuery, oldSearchQuery) {
      this.startGetData()
    },
    'orderFilter': function (newValue, oldValue) {
      if(!oldValue.key && !oldValue.type) return
      if(newValue.key === oldValue.key && newValue.type === oldValue.type) return
      this.startGetData()
    },
    selectedRows(newValue, oldValue) {
      this.$emit('changeSelectedRows', newValue)
    },
    isLoadingData(newValue, oldValue) {
      this.$emit('changeIsLoadingData', newValue)
    },
    data: {
      handler(newValue, oldValue) {
        this.$emit('changeData', newValue)
      },
      deep: true,
    }
  },
  created() {
    this.orderFilter = this.defaultOrderFilter ?? {
      key: this.tableHeaders[0].key,
      type: filterTypes.asc,
    }
  },
} 
</script>

<template>
  <div :style="`${isLoadingData ? 'user-select: none; opacity: .75' : ''}`">
    <Header
      :defaultOrderFilter="orderFilter" 
      :disabled-filters="isLoadingData"
      :isVisibleCSVButton="csvAction && csvAction.isActive"
      :isVisibleSearch="!disableSearch"
      @csvClick="startDownloadCsv"
      @changePerPage="handleChangePerPage" 
      @changeSearchQuery="handleChangeSearchQuery"
      
    />
    <Content
      ref="contentRef" 
      :table-headers="tableHeaders"
      :rows="data"
      :defaultOrderFilter="defaultOrderFilter"
      :isVisibleOrderByColumn="!disableOrderByColumn"
      :disableSelection="disableSelection"
      :isLoadingData="isLoadingData"
      :disableActions="disableActions"
      :rowKey="rowKey"
      @changeOrderFilter="handleChangeOrderFilter"
      @changeSelectedRows="selectedRows = $event"
    >
        <template v-for="contentSlot in contentSlots" v-slot:[contentSlot.name]="slotProps">
          <slot :name="contentSlot.name" v-bind:row="slotProps.row" />
        </template>
        <template v-slot:actions="slotProps">
         <slot name="actions" v-bind:row="slotProps.row" />
        </template>
    </Content>
    <Footer
      v-if="!isLoadingData"
      :pagination="pagination"
      :disabled-pagination="isLoadingData"
      @changePage="handleChangePage"
    />
  </div>
</template>